import React from 'react';
import PropTypes from 'prop-types';

function CloseBtn({ styles, ...props }) {
    const { color, height, width, ...style } = styles;

    return (
        <button style={style} type="button" {...props}>
            <svg
                width={typeof width === 'number' ? `${width}px` : width}
                height={typeof height === 'number' ? `${height}px` : height}
                viewBox="0 0 18 18"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                preserveAspectRatio="xMidYMid"
            >
                <g>
                    <path
                        d="M8.13911129,9.00268191 L0.171521827,17.0258467 C-0.0498027049,17.248715 -0.0498027049,17.6098394 0.171521827,17.8327545 C0.28204354,17.9443526 0.427188206,17.9998706 0.572051765,17.9998706 C0.71714958,17.9998706 0.862013139,17.9443526 0.972581703,17.8327545 L9.0000937,9.74924618 L17.0276057,17.8327545 C17.1384085,17.9443526 17.2832721,17.9998706 17.4281356,17.9998706 C17.5729992,17.9998706 17.718097,17.9443526 17.8286656,17.8327545 C18.0499901,17.6098862 18.0499901,17.2487618 17.8286656,17.0258467 L9.86135722,9.00268191 L17.8340066,0.973848225 C18.0553311,0.750979934 18.0553311,0.389855532 17.8340066,0.16694039 C17.6126821,-0.0556467968 17.254037,-0.0556467968 17.0329467,0.16694039 L9.00042166,8.25611765 L0.967006424,0.167268345 C0.745681892,-0.0553188426 0.387317931,-0.0553188426 0.165993399,0.167268345 C-0.0553311331,0.390136635 -0.0553311331,0.751261038 0.165993399,0.974176179 L8.13920499,9.00268191 L8.13911129,9.00268191 Z"
                        fill={color}
                    />
                </g>
            </svg>
        </button>
    );
}

CloseBtn.propTypes = {
    styles: PropTypes.object.isRequired,
};


export default class JoyrideCustomTooltip extends React.Component {
    static propTypes = {
        backProps: PropTypes.object.isRequired,
        closeProps: PropTypes.object.isRequired,
        continuous: PropTypes.bool.isRequired,
        index: PropTypes.number.isRequired,
        isLastStep: PropTypes.bool.isRequired,
        primaryProps: PropTypes.object.isRequired,
        size: PropTypes.number.isRequired,
        skipProps: PropTypes.object.isRequired,
        step: PropTypes.object.isRequired,
        tooltipProps: PropTypes.object.isRequired,
    };

    render() {
        const {
            backProps,
            closeProps,
            continuous,
            index,
            isLastStep,
            primaryProps,
            size,
            skipProps,
            step,
            tooltipProps,
        } = this.props;
        const {
            content,
            hideBackButton,
            hideCloseButton,
            hideFooter,
            showProgress,
            showSkipButton,
            title,
            styles,
        } = step;
        const { back, close, last, next, skip } = step.locale;
        const output = {
            primary: close,
        };

        if (continuous) {
            output.primary = isLastStep ? last : next;

            if (showProgress && size > 1 && (index + 1) < size ) {
                output.primary = (
                    <span>
            {output.primary} ({index + 1}/{size})
          </span>
                );
            }
        }

        if (showSkipButton) {
            output.skip = (
                <button
                    style={styles.buttonSkip}
                    type="button"
                    data-test-id="button-skip"
                    aria-live="off"
                    {...skipProps}
                >
                    {skip}
                </button>
            );
        }

        if (!hideBackButton && index > 0) {
            output.back = (
                <button style={styles.buttonBack} type="button" data-test-id="button-back" {...backProps}>
                    {back}
                </button>
            );
        }

        output.close = !hideCloseButton && (
            <CloseBtn styles={styles.buttonClose} data-test-id="button-close" {...closeProps} />
        );

        return (
            <div
                key="JoyrideTooltip"
                className="react-joyride__tooltip"
                style={styles.tooltip}
                {...tooltipProps}
            >
                <div style={styles.tooltipContainer}>
                    {title && (
                        <h4 style={styles.tooltipTitle} aria-label={title}>
                            {title}
                        </h4>
                    )}
                    <div style={styles.tooltipContent} dangerouslySetInnerHTML={{ __html: content }}></div>
                </div>
                {!hideFooter && (
                    <div style={styles.tooltipFooter}>
                        <div style={styles.tooltipFooterSpacer}>{output.skip}</div>
                        {output.back}
                        <button
                            style={styles.buttonNext}
                            type="button"
                            data-test-id="button-primary"
                            {...primaryProps}
                        >
                            {output.primary}
                        </button>
                    </div>
                )}
                {output.close}
            </div>
        );
    }
}
